// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"TertieryHeroBanner_subtitle__4ksZt","tertiaryHeroBannerImage":"TertieryHeroBanner_tertiaryHeroBannerImage__8tNEQ"};